function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { debounce as h } from "../../function/debounce.js";
function g(a) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var u = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  _typeof(u) != "object" && (u = {});
  var _u = u,
    f = _u.signal,
    _u$leading = _u.leading,
    s = _u$leading === void 0 ? !1 : _u$leading,
    _u$trailing = _u.trailing,
    d = _u$trailing === void 0 ? !0 : _u$trailing,
    o = _u.maxWait,
    i = Array(2);
  s && (i[0] = "leading"), d && (i[1] = "trailing");
  var e,
    n = null;
  var l = h(function () {
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }
      e = a.apply(this, t), n = null;
    }, r, {
      signal: f,
      edges: i
    }),
    c = function c() {
      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }
      if (o != null) {
        if (n === null) n = Date.now();else if (Date.now() - n >= o) return e = a.apply(this, t), n = Date.now(), l.cancel(), l.schedule(), e;
      }
      return l.apply(this, t), e;
    },
    p = function p() {
      return l.flush(), e;
    };
  return c.cancel = l.cancel, c.flush = p, c;
}
export { g as debounce };